<template>
  <div class="left-menu">
    <el-popover
        placement="bottom"
        popper-class="popoverpopover"
        width="200"
        trigger="hover"
        v-show="hasPermission(6) || hasPermission(7)"
    >
      <div class="popBox">
        <div @click="isHYJG ? $router.push('/issue') : go({url:'/release/0',id:'Release'})" class="popItem" v-show="hasPermission(6)">
          <img src="@/assets/song.png" />
          <span>发布歌曲</span>
        </div>
        <div  @click="go({url:'/demo/0',id:'demo'})" class="popItem" v-show="hasPermission(7)">
          <img src="@/assets/lrc.png" />
          <span>出售词曲</span>
        </div>
      </div>
      <div slot="reference" class="publishBtn">
        <img src="@/assets/feiji.png" />
        <span>发布作品</span>
      </div>
    </el-popover>
    <template v-for="(item) in list" >
      <!-- 判断是否为学生 -->
      <template v-if="(item.name ==='分贝学院'&&(hiddenic===0&&isTrain===1)||item.name !=='分贝学院') && !(!isCompany && item.name === '机构管理')">
        <div class="item" :key="item.name" style="color: #666666;padding-top: 28px;font-weight: 600" v-show="hasPermission(item.children)">
          {{item.name}}
        </div>
        <template v-for="(i) in item.children" >
          <div class="item" :key="i.id" :class="{active: current === i.id}"  @click="$route.name === i.id ? go(0) : go(i)" v-show="hasPermission(i.permissionId)">
            <img :src="i[i.id === current ? 'activeIcon':'icon']" class="icon"  alt=""/>
            {{i.name}}
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import DataCenter from "@/assets/menu/data-center.png"
import DataCenterActive from "@/assets/menu/data-center-active.png"
export default {
  props:{
    current: String
  },
  computed: {
    hiddenic(){
      return this.$store.state.user.webLoginType
    },
    //  获取学院身份 通过usermsg拿
    isTrain(){
      return this.$store.state.usermsg.isTrain
    },
    permissionIds(){
      return this.$store.state.roleInfo && this.$store.state.roleInfo.subIds ? this.$store.state.roleInfo.subIds : []
    },
    isCompany(){
      return this.$store.state.usermsg.webLoginType === 1
    },
    isAdmin(){
      return this.$store.state.usermsg.userCompanyVo.managerUser === 1
    },
    isHYJG(){
      return (this.isCompany && this.$store.state.usermsg.userCompanyVo) ? this.$store.state.usermsg.userCompanyVo.companyType === 1 : false
    },

  },
  mounted() {
    if (this.$store.state.user.isTrendShow === 1) {
      this.list[2].children.push(
          {
            id: 'tme',
            name: '作品趋势',
            url: '/tme',
            icon: '/assets/data.png',
            activeIcon: '/assets/data-active.png'
          }
      )
    }
    if(this.hiddenic===0&&this.isTrain===1){
      this.list.push( )
    }
    // if(this.hiddenic!=1){
    //    this.list[0].children.push(
    //         {
    //           id: 'demo-list',
    //           name: '词曲DEMO列表',
    //           url: '/demo-list',
    //           icon: '/assets/3.png',
    //           activeIcon: '/assets/4.png'
    //         }
    //    )
    // }
  },
  data(){
    return {
      DataCenter,
      DataCenterActive,
      list:[
        {
          name: '作品管理',
          children: [
            {
              id: 'songManage',
              name: '发行管理',
              url: '/song-manage',
              icon: '/assets/1.png',
              activeIcon: '/assets/2.png',
              permissionId: 8
            },
            {
              id: 'demo-list',
              name: '词曲管理',
              url: '/demo-list',
              icon: '/assets/3.png',
              activeIcon: '/assets/4.png',
              permissionId: 9
            }
          ]
        },

        {
          name: '数据中心',
          children: [
            {
              id: 'Income',
              name: '收益数据',
              url: '/income',
              icon: '/assets/13.png',
              activeIcon:'/assets/14.png',
              permissionId: 10
            },
            {
              id: 'trends',
              name: '作品表现',
              url: '/trends',
              icon: DataCenter,
              activeIcon: DataCenterActive,
              permissionId: 11
            }
          ]
        },
        {
          name: '机构管理',
          children: [
            {
              id: 'Company',
              name: '机构设置',
              url: '/company',
              icon: '/assets/company.png',
              activeIcon:'/assets/company-active.png',
              permissionId: 17
            },
            {
              id: 'memberManagement',
              name: '成员管理',
              url: '/member-management',
              icon: '/assets/member.png',
              activeIcon:'/assets/member-active.png',
              permissionId: 14
            },
            {
              id: 'memberDynamic',
              name: '成员动态',
              url: '/member-dynamic',
              icon: '/assets/member-dynamics.png',
              activeIcon:'/assets/member-dynamics-active.png',
              permissionId: 13
            },
            // {
            //   id: 'b',
            //   name: '艺人管理',
            //   url: '/income',
            //   icon: DataCenter,
            //   activeIcon: DataCenterActive,
            //   permissionId: 16
            // },
            {
              id: 'ArtistManagement',
              name: '艺人管理',
              url: '/artist-management',
              icon: '/assets/singer.png',
              permissionId: 16,
              activeIcon: '/assets/singer-active.png',
            },
            // {
            //   id: 'Permission',
            //   name: '权限管理',
            //   url: '/permission',
            //   icon: '/assets/jurisdiction.png',
            //   activeIcon: '/assets/jurisdiction-active.png',
            //   permissionId: 15
            // }
          ]
        },
        {
          name: '分贝学院',
          children: [
            {
              id: 'taskrun',
              name: '作业管理',
              url: '/taskrun',
              icon: '/assets/taskrun.png',
              activeIcon:'/assets/taskrun-active.png'
            }
          ]
        }
      ]
    }
  },
  methods:{
    hasPermission(id) {
      if (id === 16 && this.isCompany && !this.isHYJG) return false
      return !this.isCompany || this.isAdmin || this.permissionIds.find(e => typeof id === 'object' ? id.find(f => e === f.permissionId) : e === id)
    },
    go(item){
      console.log(this.$route.name, item.id)
      if (this.isHYJG) {
        this.list[0].children[0].url = '/applyList'
        this.list[0].children[0].id = 'applyList'
      }
      // 点击当前项不做跳转
      if(this.current == item.id){
        if( 'Release' === this.current &&'Release'===item.id){
          this.$router.replace('/release/0').catch(()=>{
            console.log('路由重复跳转')
          })
          this.$router.go(0)
          this.$emit('continueSubmission')
          return false
        }else {
          return false
        }
      }
      this.$router.replace(item.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.popoverpopover{
  .popBox{
    display: flex;
    justify-content: space-around;
    font-family:PingFang SC;
    .popItem{
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img{
        width: 40px;
        height: 40px;
      }
      span{
        padding: 10px 0;
      }
    }
  }
}
.left-menu{
  width: 200px;
  min-width: 200px;
  background: #FFFFFF;
  padding: 20px 0;
  border-radius:4px;
  box-sizing: border-box;

  .publishBtn{
    width: 160px;
    height: 34px;
    opacity: 1;
    background: #ff004d;
    border-radius: 2px;
    color: #FFFFFF;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 20px;
    img{
      width: 14px;
      height: 14px;
      margin-right: 7px;
    }
  }
  .item{
    padding: 18px 26px;
    display: flex;
    align-items: center;

    height: 14px;
    font-size: 14px;
    font-family:PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 14px;
    cursor: pointer;
    .icon{
      width: 18px;
      height: 18px;
      display: block;
      margin-right: 13px;
    }
  }
  .active{
    color: $base-color;
    position: relative;
    &::before{
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 30px;
      background: $base-color;
    }
  }
}
</style>
